import Component from '@glimmer/component'
import Icon from 'customer-flows/components/ui-kit/icon'
import t from 'ember-intl/helpers/t'

interface StickyFooterSignature {
  Args: {
    hidden?: boolean
  }
  Blocks: {
    default: []
  }
}

export default class StickyFooter extends Component<StickyFooterSignature> {
  <template>
    <div data-testid='sticky-footer' data-hidden="{{@hidden}}" class='pt-5 {{if @hidden "overflow-hidden" "overflow-visible"}}'>
      <il-page-footer
        data-testid='sticky-footer__container'
        class='ease-in-out-cubic pointer-events-auto sticky bottom-0 block w-full transition-[translate] duration-200
          {{if @hidden "translate-y-full" "shadow-cool-raised"}}'
      >
        <div
          data-testid='sticky-footer'
          class='grid w-full items-start gap-4 grid-cols-1 justify-items-center @md/flow:grid-cols-[1fr_minmax(402px,_637px)_402px_1fr] @md/flow:gap-0 @xl/flow:gap-4'
        >
          <div
            data-testid='sticky-footer__content--left'
            class='hidden @md/flow:col-start-2 @md/flow:flex @md/flow:items-center @md/flow:gap-2 @md/flow:justify-self-start @md/flow:self-center'
          >
            <Icon @src='peek-logo' />
            <div data-testid='sticky-footer__logo-text' class='[&_a]:underline'>
              {{t 'booking.footer.text' htmlSafe=true}}
            </div>
          </div>
          <div
            data-testid='sticky-footer__content--right'
            class='flex w-full flex-col items-center gap-4'
          >
            {{yield}}
          </div>
        </div>
      </il-page-footer>
    </div>
  </template>
}
